const setImportSheetModalState = (state, payload) => {
  state.openModalImportSheet = payload
}

const setAIRequestLimitModalState = (state, payload) => {
  state.isAIRequestLimitModalVisible = payload
}

const setShowModalTemplateLibraryState = (state, payload) => {
  state.isShowModalTemplateLibrary = payload
}

export default {
  setImportSheetModalState,
  setAIRequestLimitModalState,
  setShowModalTemplateLibraryState,
}
